import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/mainPage";
import SecretPage from "../pages/secretPage";

export default function RoutesApp() {

    return(
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/SecretPage" element={<SecretPage />} />
        </Routes>
    )
}